import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { initAnalytics } from "@/lib/analytics";
import { SERVICE_PAGES } from "@/data/services";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Pricing from "@/pages/Pricing";
import HowItWorks from "@/pages/HowItWorks";
import TaxGuide from "@/pages/TaxGuide";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
  // TEMPORARILY DISABLED FOR MOBILE SCROLL TEST
  // const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  // window.__lenis = lenis;
  // let raf;
  // const loop = (time) => {
  //   lenis.raf(time);
  //   raf = requestAnimationFrame(loop);
  // };
  // raf = requestAnimationFrame(loop);

  initAnalytics();

  return () => {
    // cancelAnimationFrame(raf);
    // lenis.destroy();
  };
}, []);
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/nri-tax-tds-guide" element={<TaxGuide />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
            {Object.keys(SERVICE_PAGES).map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<ServiceDetail slug={slug} />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
